import { render, staticRenderFns } from "./SmallSavedPropertyCard.vue?vue&type=template&id=510b3c85"
import script from "./SmallSavedPropertyCard.vue?vue&type=script&lang=ts"
export * from "./SmallSavedPropertyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports